<template>
    
  <div class="row">
    <Loader v-if="!resourceLoaded" />
    <div class="col-12" v-if="resourceLoaded">
      <div class="panel-content-inner">
        <div class="row">
          <table id="users-table" class="table table-responsive" >
            <thead>
            <tr>
              <th>{{ $t('admin.index.users.avatar') }}</th>
              <th>{{ $t('input.first_name') }}</th>
              <th>{{ $t('input.last_name') }}</th>
              <th>{{ $t('input.email') }}</th>
              <!--<th>{{ $t('input.username') }}</th>-->
              <th>{{ $t('admin.index.users.actions') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="owner in owners" :key="owner.id">
                <td>
                    <img :src=" owner.avatar ? owner.avatar : 'static/material/global/portraits/avatar.png' "
                         class="users-avatar img-responsive"/>
                  </td>
                  <td>{{ owner.first_name }}</td>
                  <td>{{ owner.last_name }}</td>
                  <td>{{ owner.email }}</td>
                  <!--<td>{{ owner.username }}</td>-->
                  <td>
                    <div class="channel-change">
                      <div class="btn-group">
                        <div class="dropdown">
                          <button class="btn btn-primary dropdown-toggle" type="button"
                                  data-toggle="dropdown"><i class="bulle"></i></button>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a :href="'#/update-user/' + owner.id"
                               class="dropdown-item waves-effect waves-light waves-round">{{$t("button.edit") }}</a>
                            <a href="#"
                               class="dropdown-item waves-effect waves-light waves-round"
                               @click.prevent="deleteTeamMember(owner.id)">{{$t("admin.index.users.delete") }}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import superconciergerie from '../../../services/superconciergerie';
import accountService from '../../../services/account';

export default {
  data() {
    return {
      resourceLoaded: false,
      owners: [],
    };
  },

  methods: {
    deleteTeamMember(id) {
      let vm = this;
      swal({
          title: "Are you sure?",
          text: '<div style="display: none; height: 100px" id="loading1" class="loader-wrapper"><div class="md-preloader"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="4"/></svg></div></div><div>You will not be able to recover this user</div>',
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: 'Yes, delete it!',
          closeOnConfirm: false,
          html: true
        },
        function () {
          $(".cancel").addClass("disabled");
          $(".confirm").addClass("disabled");
          $(".pulseWarning").hide();
          $("#loading1").show();
          accountService.deleteTeamMembers(vm, id);
        });
    },
    async loadResource() {
      if(this.activeTab === 'summary' && !this.resourceLoaded) {
        await superconciergerie.getOwners(this);
        this.resourceLoaded = true;
      }
    },
  },
  props: ['activeTab'],
  async mounted() {
    await this.loadResource();
  },
  watch: {
    activeTab: async function (val) {
      await this.loadResource();
    }
  },
  components: {
    Loader: require('../components/Loader.vue'),
  },
};

</script>



// WEBPACK FOOTER //
// SummaryTab.vue?99836eda